import styled from '@emotion/styled'

export const KP11LinkCatalogContainerStyle = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  .catalog-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    gap: 1rem;
    padding: 0 0 20px 0;
  }
  .catalog-header-left {
    display: flex;
    flex-direction: column;
  }
  .back-link {
    color: white;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    margin-bottom: 4px;
  }
  .back-link:hover {
    cursor: pointer;
  }
  .brand-title {
    color: white;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: 0;
  }
  .customer-info-card {
    background: linear-gradient(145deg, #fffaf8 0%, #ffffff 60%);
    border-radius: 12px;
    border-left: 5px solid #ff5000;
    padding: 14px 18px 13px 14px;
    min-width: 280px;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    gap: 0;
    box-shadow: 0 4px 20px rgba(255, 80, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  .customer-info-main {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    margin-bottom: 11px;
  }
  .customer-avatar {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff5000 0%, #ff7c3a 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-size: 16px;
    text-transform: uppercase;
    box-shadow: 0 2px 8px rgba(255, 80, 0, 0.3);
  }
  .customer-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
  }
  .customer-label {
    font-family: 'Open Sans', sans-serif;
    font-size: 9.5px;
    font-weight: 700;
    color: #ff5000;
    text-transform: uppercase;
    letter-spacing: 0;
    margin-bottom: 1px;
  }
  .customer-company {
    font-family: 'Open Sans', sans-serif;
    font-weight: 800;
    font-size: 15px;
    color: #1a1a2e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }
  .customer-name {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 12.5px;
    color: #6b7280;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .customer-meta {
    display: flex;
    flex-direction: column;
    gap: 7px;
    padding-top: 10px;
    border-top: 1px solid rgba(229, 231, 235, 0.8);
  }
  .customer-meta-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  .customer-meta-row .label {
    font-family: 'Open Sans', sans-serif;
    font-size: 9.5px;
    font-weight: 700;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0;
    white-space: nowrap;
    min-width: 48px;
  }
  .customer-meta-row .value {
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    font-weight: 700;
    color: #374151;
    letter-spacing: 0;
    background: #f3f4f6;
    padding: 2px 7px;
    border-radius: 4px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .customer-meta-row .customer-bill-to-value {
    font-family: 'Open Sans', sans-serif;
  }
`
